module.exports = __webpack_public_path__ + "static/media/cat.93a0cce7.gif";